import { apiCall } from '@shared/entity';
import { axiosInstance } from '@libs/axios/axios';
import { DemoUserRegistrationData } from './queries';

export const demoUserApi = {
  register: () => '/api/demo-user/register',
};

export const postRegisterDemoUser = async (data: DemoUserRegistrationData): Promise<void> =>
  apiCall(
    async () => await axiosInstance.post(demoUserApi.register(), data),
    'api.demo.registerError',
  );
export const getRegisterDemoUser = async (): Promise<DemoUserRegistrationData> =>
  apiCall(async () => await axiosInstance.get(demoUserApi.register()), 'api.demo.registerError');
